import { Component, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common'
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { GeoArea } from 'src/app/assabil-kernel/models/entities/control-tables/geo-area-entity';
import { GeoAreaMslMonitoringKpi } from 'src/app/assabil-sales/models/dtos/geo-area-msl-monitoring-kpi';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { LeanDataFormComponent } from 'src/app/tools/components/lean-data-form/lean-data-form.component';
import { SpecificDanoneService } from 'src/app/assabil-sales/services/specific_danone_service';
import { SkuMslKpi } from 'src/app/assabil-kernel/models/entities/control-tables/sku-msl-kpi-entity';
import { Partnercluster } from 'src/app/assabil-sales/models/entities/partnercluster';


  @Component({
    selector: 'danone-msl-monitoring-widget',
    templateUrl: './danone-msl-monitoring-widget.component.html',
    styleUrls: ['./danone-msl-monitoring-widget.component.scss']
  })
  
  export class DanoneMslMonitoringWidgetComponent extends BaseWidget {

    @ViewChild('leanDataForm', {static : false}) leanDataForm : LeanDataFormComponent;
  
    geoArea             : GeoArea;
    selectedGeoArea     : GeoArea = null
    date                : Date = new Date();
    dateTemp            : Date = new Date();
    title               : string = "Monitoring DN MSL";
    detailSkusTitle        : string = "";
    detailSkuGeoAreasTitle : string = "";
    previousPeriod      : string = "12/2030";

    itineraryType  : string;
    partnerCluster : string;
    geoAreaCode    : string;
    geoAreaName    : string;
    kpi            : string;
    periodActiveDay: Date;

    geoAreaMslMonitoringKpi :  GeoAreaMslMonitoringKpi;

    mslSkus        : any[] = [];
    mslSkuGeoAreas : any[] = [];

    SkuDetailsColumns = [
  
      { prop: 'productCode',      name: 'Code SKU',                         },
      { prop: 'productName',      name: 'Designation',                      },
      { prop: 'allClustersDn',    name: 'ALL Clusters',                     },
  
      { prop: 'clusterAPlusDn',   name: 'Cluster A+',                       },
      { prop: 'clusterADn',       name: 'Cluster A',                        },
      { prop: 'clusterBDn',       name: 'Cluster B',                        },
      { prop: 'clusterCDn',       name: 'Cluster C',                        },
      { prop: 'clusterDDn',       name: 'Cluster D',                        },
      { prop: 'clusterDMinusDn',  name: 'Cluster D-',                       },
  
    ]

    SkuGeoAreasDetailsColumns = [
  
      { prop: 'geoAreaCode',      name: 'Code Area',                         },
      { prop: 'geoAreaName',      name: 'Designation',                      },
      { prop: 'allClustersDn',    name: 'ALL Clusters',                     },
  
      { prop: 'clusterAPlusDn',   name: 'Cluster A+',                       },
      { prop: 'clusterADn',       name: 'Cluster A',                        },
      { prop: 'clusterBDn',       name: 'Cluster B',                        },
      { prop: 'clusterCDn',       name: 'Cluster C',                        },
      { prop: 'clusterDDn',       name: 'Cluster D',                        },
      { prop: 'clusterDMinusDn',  name: 'Cluster D-',                       },
  
    ]


    showPartnerList   : boolean = false;
    showSkusDn        : boolean = false;
    showSkuGeoAreasDn : boolean = false;
    

    constructor(
      protected datepipe: DatePipe,
      protected specificDanoneService   : SpecificDanoneService,
      protected controlTablesService    : ControlTablesService,
      protected leanUtilsService        : LeanUtilsService,
      protected masterDataService       : MasterDataService,
      protected toastr                  : ToastrService,
      protected router                  : Router,
      protected location                : Location) {
        super(toastr, leanUtilsService);
        
  
    }
  
  //----------------------------------------------------------------------------------------------------------------------------------
  ngOnInit(){
    this.date.setDate(this.date.getDate() - 1);
    super.ngOnInit();
    this.controlTablesService.personGeoAreaGet().then(result => {
      this.geoArea = result;
    })
  }
  //----------------------------------------------------------------------------------------------------------------------------------


  //----------------------------------------------------------------------------------------------------------------------------------
  loadData() {
    if ( (! this.selectedGeoArea) ||   (! this.date) ){
      this.toastr.error("Prière de préciser les paramètres de la recherhe");
      return;
    }
    
    this.specificDanoneService.geoAreaMslMonitoringKpisGet(this.selectedGeoArea.geoAreaCode, this.date).then(geoAreaMslMonitoringKpi => {
        this.geoAreaMslMonitoringKpi = geoAreaMslMonitoringKpi;
    })
    this.dateTemp.setFullYear(this.date.getFullYear(), this.date.getMonth() - 1, this.date.getDate());
    this.title = "Suivi DN MSL - Date : " + this.datepipe.transform(this.date, 'dd/MM/yyyy') + " | " + this.selectedGeoArea.name;
  }
 //----------------------------------------------------------------------------------------------------------------------------------

 //----------------------------------------------------------------------------------------------------------------------------------

 itineraryTypeclicked(event : any){
  this.itineraryType   = event.itineraryType;
  this.partnerCluster  = event.partnerCluster;
  this.geoAreaCode     = event.geoArea.geoAreaCode;
  this.geoAreaName     = event.geoArea.name;
  this.periodActiveDay = this.date;

  this.specificDanoneService.danoneMslSkusGet(this.periodActiveDay, this.itineraryType, this.geoAreaCode).then(danoneMslSkus => {
    this.mslSkus  = danoneMslSkus;
    this.showSkusDn = true;
    this.detailSkusTitle = "Détail DN SKUs - Date: " + this.datepipe.transform(this.date, 'dd/MM/yyyy') + " | Type Tournées: " + event.itineraryTypeName +  " | Area: " + event.geoArea.name

    // console.log("skuMslKpi : ", danoneMslSkus)
    // console.log("itineraryType : ", this.itineraryType)
    // console.log("partnerCluster : ", this.partnerCluster)
    // console.log("geoAreaCode : ", this.geoAreaCode)
})
}
//----------------------------------------------------------------------------------------------------------------------------------


  //----------------------------------------------------------------------
  selectGeoAreaAndGo(geoArea : GeoArea){ 
    this.selectGeoArea(geoArea);
    this.leanDataForm.hideFilter();
    this.loadData();
  }
  selectGeoArea(geoArea : GeoArea){
    if (this.selectedGeoArea != null) this.selectedGeoArea.selected = false;
    this.selectedGeoArea = geoArea;
    this.selectedGeoArea.selected=true;
  }
//----------------------------------------------------------------------


//--------------------------------------------------------------------------------------
returnBack(){
  this.location.back();
}
//--------------------------------------------------------------------------------------

processSelectedSku(event : any){
  // console.log("periodActiveDay : ", this.periodActiveDay)
  // console.log("itineraryType : ", this.itineraryType)
  // console.log("geoAreaCode : ", this.geoAreaCode)
  // console.log("selected sku : ", event.productCode)

  this.specificDanoneService.danoneMslSkuGeoAreasGet(this.periodActiveDay, event.productCode, this.geoAreaCode).then(result => {
    this.mslSkuGeoAreas  = result;
    this.showSkusDn = false;
    this.showSkuGeoAreasDn = true;
    this.detailSkuGeoAreasTitle = "Détail DN - Date: " + this.datepipe.transform(this.periodActiveDay, 'dd/MM/yyyy') + " | SKU: " + event.productCode +  " | Area: " + this.geoAreaName

    // console.log("event.geoArea.name : ", this.geoAreaName)
    // console.log("detailSkuGeoAreasTitle : ", this.detailSkuGeoAreasTitle)
})

  
}
//--------------------------------------------------------------------------------------
  setEntity(data: BaseEntity) {
    throw new Error("Method not implemented.");
  }
  getEntity(): BaseEntity {
    throw new Error("Method not implemented.");
  }
  saveRow(): Promise<BaseEntity> {
    throw new Error("Method not implemented.");
  }
  //--------------------------------------------------------------------------------------
    
  }
  
  